"use client";

import { Box, Typography, Button, Container } from "@mui/material";
import { styled } from "@mui/material/styles";
import team1 from "../../../assets/images/team-member-1.png";
import team2 from "../../../assets/images/team-member-2.png";
import team3 from "../../../assets/images/team-member-3.png";
import team4 from "../../../assets/images/team-member-4.png";
import team5 from "../../../assets/images/team-member-5.png";
import team6 from "../../../assets/images/team-member-6.png";
import Animator from "../../../components/Aminator/Animator";

// Styled components
const BannerContainer = styled(Box)(({ theme }) => ({
  position: "relative",
  width: "100%",
  height: "400px",
  display: "flex",
  alignItems: "center",
  overflow: "hidden",
  backgroundColor: "#000",
  borderRadius: "12px",
  paddingBottom: "20px",
}));

const BannerContent = styled(Box)(({ theme }) => ({
  position: "relative",
  zIndex: 2,
  maxWidth: "550px",
  color: "#fff",
  paddingLeft: theme.spacing(8),
  paddingRight: theme.spacing(4),
  [theme.breakpoints.down("md")]: {
    paddingLeft: theme.spacing(4),
    paddingRight: theme.spacing(2),
  },
}));

const ContactButton = styled(Button)(({ theme }) => ({
  backgroundColor: "#FF5722",
  color: "#fff",
  padding: "10px 24px",
  borderRadius: "4px",
  textTransform: "none",
  fontWeight: 600,
  fontSize: "16px",
  "&:hover": {
    backgroundColor: "#E64A19",
  },
}));

const BackgroundImageContainer = styled(Box)({
  position: "absolute",
  right: 0,
  top: 0,
  width: "60%",
  height: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
});

const BackgroundImage = styled(Box)(({ src, leftOffset, opacity = 0.6 }) => ({
  width: "250px",
  height: "400px",
  backgroundImage: `url(${src})`,
  backgroundSize: "cover",
  backgroundPosition: "center",
  filter: "blur(4px)",
  opacity: opacity,
  position: "absolute",
  right: leftOffset,
}));

function TrainingTalentBanner() {
  return (
    <Box sx={{ pb: 4 }}> {/* Adds space below the container */}
      <Container maxWidth="lg">
        <BannerContainer>
          {/* Left-side content */}
          <BannerContent>
             <Animator variant="slide" timeout={500} delay={200}>
            <Typography
              variant="h3"
              component="h1"
              sx={{
                fontFamily: "Monserrat, sans-serif",
                fontWeight: 700,
                mb: 2,
                fontSize: { xs: "28px", sm: "32px", md: "40px" },
              }}
            >
              Training & Talent Sourcing
            </Typography>
            </Animator>
            <Animator variant="slide" timeout={800} delay={300}>
            <Typography
              variant="body1"
              sx={{
                fontFamily: "Monserrat, sans-serif",
                mb: 4,
                lineHeight: 1.6,
                fontSize: { xs: "14px", sm: "16px" },
                opacity: 0.9,
              }}
            >
              Don’t let the search for top talent slow you down. Whether you’re looking to hire or ready to take your career to the next level, E1x is here to connect you with the right people at the right time.
            </Typography>
            </Animator>
             <Animator variant="slide" timeout={800} delay={400}>
            <ContactButton onClick={() => window.location.href = "/talents/hire"}>Contact Us</ContactButton>
             </Animator>
          </BannerContent>

          {/* Right-side images */}
          <BackgroundImageContainer>
            <BackgroundImage src={team1} leftOffset="50px" opacity={0.7} />
            <BackgroundImage src={team2} leftOffset="150px" opacity={0.6} />
            <BackgroundImage src={team3} leftOffset="250px" opacity={0.5} />
            <BackgroundImage src={team4} leftOffset="350px" opacity={0.4} />
            <BackgroundImage src={team5} leftOffset="450px" opacity={0.3} />
            <BackgroundImage src={team6} leftOffset="550px" opacity={0.2} />
          </BackgroundImageContainer>
        </BannerContainer>
      </Container>
    </Box>
  );
}

export default TrainingTalentBanner;
